export default __webpack_public_path__ + "static/media/43.aad195f0.jpg";